import { combineReducers } from 'redux';
import simpleReducer from './simpleReducer';
import fillReducer from './fillReducer/fillReducer';
import countDownDateReducer from './staticReducer/staticReducer';

export default combineReducers({
    simpleReducer,
    fillReducer,
    countDownDateReducer,
});